export enum InvestmentWalletQueryKeys {
  Primary = 'investment-wallet/',
  GetInvestmentWallet = 'investment-wallet/get-by-user',
}
